import isMailFeatureEnabled from './isMailFeatureEnabled';
export default function isReadingPaneCardUIEnabled() {
    return isMailFeatureEnabled('rp-cardUI');
}
//# sourceMappingURL=isReadingPaneCardUIEnabled.js.map